<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="member-filtering"
			title="メンバーフィルタリング"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<div class="modal-header-member-filtering">
					<v-btn flat blue large color="white" v-on:click="onClickDone">登録</v-btn>
					<v-btn flat blue large color="white" v-on:click="onClickClear">クリア</v-btn>
				</div>
			</template>
			<template v-if="display">
				<v-layout v-if="display_date" row wrap mt-2 mx-2 class="row-group">
					<v-flex xs10 class="label">
						割当期間
					</v-flex>
					<v-flex xs5 class="label">
						<v-menu
							ref="beginCalendar"
							v-model="beginCalendar"
							:close-on-content-click="false"
							:return-value.sync="value.begin"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="displayBegin"
									label="開始日"
									v-on="on"
									readonly 
									@focus="beginDatePicker = true"
									:append-icon="beginIcon ? 'clear' : ''"
									@click:append="beginClear"
									:rules="[rules.requiredBegin, rules.integrityDate]"
									ref="begin_date"
								></v-text-field>
							</template>
							<v-date-picker
								v-if="beginDatePicker"
								v-model="value.begin"
								no-title locale="jp-ja"
								:day-format="date => new Date(date).getDate()"
								@input="beginDatePicker = false"
								:max="beginFuturePeriod"
							>
							</v-date-picker>
							<div class="btn-term-group" v-if="!beginDatePicker">
								<v-layout wrap align-space-around column>
									<div class="text-xs-center subheading ma-1">{{value.begin}}</div>
									<v-btn flat color="primary" @click="onClickBeginTermAm">AM</v-btn>
									<v-btn v-if="beginPMEnable" flat color="primary" @click="onClickBeginTermPm">PM</v-btn>
									<v-btn v-else disabled flat color="primary">PM</v-btn>
								</v-layout>
							</div>
						</v-menu>
					</v-flex>
					<v-flex xs1 class="label">
						～
					</v-flex>
					<v-flex xs5 class="label">
						<v-menu
							ref="endCalendar"
							v-model="endCalendar"
							:close-on-content-click="false"
							:return-value.sync="value.end"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							full-width
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="displayEnd"
									label="終了日"
									v-on="on"
									readonly
									@focus="endDatePicker = true"
									:append-icon="endIcon ? 'clear' : ''"
									@click:append="endClear"
									:rules="[rules.requiredEnd]"
									ref="end_date"
								></v-text-field>
							</template>
							<v-date-picker
								v-if="endDatePicker"
								v-model="value.end"
								no-title locale="jp-ja"
								:day-format="date => new Date(date).getDate()"
								@input="endDatePicker = false"
								:min="endPastPeriod"
							>
							</v-date-picker>
							<div class="btn-term-group" v-if="!endDatePicker">
								<v-layout wrap align-space-around column>
									<div class="text-xs-center subheading ma-1">{{value.end}}</div>
									<v-btn v-if="endAMEnable" flat color="primary" @click="onClickEndTermAm">AM</v-btn>
									<v-btn v-else disabled flat color="primary">AM</v-btn>
									<v-btn flat color="primary" @click="onClickEndTermPm">PM</v-btn>
								</v-layout>
							</div>
						</v-menu>
					</v-flex>
				</v-layout>
				<v-layout row wrap mt-3 mx-2 class="row-group">
					<v-flex xs2 class="multi-line-label">
						分類
					</v-flex>
					<v-flex xs10 class="content">
						<GBClasses
							:items="selectedClasses"
							:max_width=230
							:all_show=true
						/>
						<v-btn
							flat
							fab
							class="btn-add-class"
							v-on:click="onClickShowClassSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBClasses from './GBClasses';
import clonedeep from 'lodash/cloneDeep';
import ScheduleTick from '../data/ScheduleTick';

const validateintegrityDate = function(thiz) {
	if (!thiz.value.begin || !thiz.value.end) return true;
	let begin = thiz.value.begin.replace(/-/g, '') + thiz.value.begin_term;
	let end = thiz.value.end.replace(/-/g, '') + thiz.value.end_term;
	if (begin <= end)
		return true;
	return false;
};
const TEXT_AM = ' AM';
const TEXT_PM = ' PM';

export default {
	name: 'GBRightPaneMemberFiltering',
	props: [
		"value",
		"display_date",
		"selected_class",
	],
	data: function (){
		return {
			beginCalendar: false,
			endCalendar: false,
			beginFuturePeriod: '',
			endPastPeriod: '',
			beginPMEnable: true,
			endAMEnable: true,
			rules: {
				requiredBegin: v => (!!v || !this.value.end) || '入力してください',
				integrityDate: () => validateintegrityDate(this) || '日付を確認してください',
				requiredEnd: v => (!!v || !this.value.begin) || '入力してください',
			},
			beginIcon: false,
			endIcon: false,
			beginDatePicker: true,
			endDatePicker: true,
		};
	},
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBClasses,
	},
	methods: {
		onClose: function() {
			this.beginCalendar = false;
			this.endCalendar = false;
			this.beginFuturePeriod = "";
			this.endPastPeriod = "";
			
			this.$emit('close');
		},
		onClickShowClassSelect: function() {
			this.$emit('show-class-select', clonedeep(this.selectedClasses));
		},
		onClickClear: function() {
			if (!this.value) {
				this.onClose();
				return;
			}
			if (this.display_date) {
				this.value.begin = null;
				this.value.begin_term = null;
				this.value.end = null;
				this.value.end_term = null;
				this.beginIcon = false;
				this.endIcon = false;
				this.beginFuturePeriod = "";
				this.endPastPeriod = "";
				Object.keys(this.form).forEach(f => {
					this.$refs[f].validate(true);
				});
			}
			this.value.classes.length = 0;
			
			this.clearButtonState();
			this.beginCalendar = false;
			this.endCalendar = false;
			
			this.$emit('clear-filtering');
		},
		onClickDone: async function() {
			if (!this.value) {
				this.onClose();
				return;
			}
			if (this.display_date) {
				Object.keys(this.form).forEach(f => {
					this.$refs[f].validate(true);
				});
				if ((!this.value.begin && this.value.end)
					|| (this.value.begin && !this.value.end)
					|| !validateintegrityDate(this)) {
						return;
				}
			}

			if (this.selected_class)
				this.value.classes = this.selected_class;
			if (!this.value.begin)
				this.value.begin_term = null;
			if (!this.value.end)
				this.value.end_term = null;
			this.$emit('do-filtering', this.value);
		},
		onClickBeginTermAm: function() {
			if (!this.value.begin) return ;
			this.value.begin_term = ScheduleTick.TERM.AM;
			this.$refs.beginCalendar.save(this.value.begin);
			this.beginCalendar = false;
			this.beginIcon = true;
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
			this.validateBegin(this.value.begin_term);
		},
		onClickBeginTermPm: function() {
			if (!this.value.begin) return ;
			this.value.begin_term = ScheduleTick.TERM.PM;
			this.$refs.beginCalendar.save(this.value.begin);
			this.beginCalendar = false;
			this.beginIcon = true;
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
			this.validateBegin(this.value.begin_term);
		},
		onClickEndTermAm: function() {
			if (!this.value.end) return ;
			this.value.end_term = ScheduleTick.TERM.AM;
			this.$refs.endCalendar.save(this.value.end);
			this.endCalendar = false;
			this.endIcon = true;
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
			this.validateEnd(this.value.end_term);
			
		},
		onClickEndTermPm: function() {
			if (!this.value.end) return ;
			this.value.end_term = ScheduleTick.TERM.PM;
			this.$refs.endCalendar.save(this.value.end);
			this.endCalendar = false;
			this.endIcon = true;
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
			this.validateEnd(this.value.end_term);
		},
		beginClear: function() {
			if (!this.value.begin) return null;
			this.value.begin = null;
			this.value.begin_term = null;
			this.beginIcon = false;
			this.endPastPeriod = "";
			
			this.endAMEnable = true;
			this.endPMEnable = true;
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
		},
		endClear: function() {
			if (!this.value.end) return null;
			this.value.end = null;
			this.value.end_term = null;
			this.endIcon = false;
			this.beginFuturePeriod = "";

			this.beginAMEnable = true;
			this.beginEnable = true;
			Object.keys(this.form).forEach(f => {
				this.$refs[f].validate(true);
			});
		},
		clearButtonState: function(){
			this.beginAMEnable =  true;
			this.beginPMEnable = true;
			this.endAMEnable = true;
			this.endPMEnable = true;
		},
		validateBegin: function(term){
			if (this.value !== undefined && this.value !== null){
				if (this.value.begin !== null && this.value.begin_term !== null){
					if (this.value.end === null){
						this.value.end = this.value.begin;
						this.value.end_term = term;
						this.endIcon = true;
					}
					this.endPastPeriod = this.value.begin;
				}
			}
		},
		validateEnd: function(term){
			if (this.value !== undefined && this.value !== null){
				if (this.value.end !== null && this.value.end_term !== null){
					if (this.value.begin === null){
						this.value.begin = this.value.end;
						this.value.begin_term = term;
						this.beginIcon = true;
					}
					this.beginFuturePeriod = this.value.end;
				}
			}
		},
		setEndAM: function(){
			if (this.value.begin !== null && this.value.begin_term !== null){
				if ( this.value.begin === this.value.end && this.value.begin_term == '1'){
					this.endAMEnable = false;
				} else {
					this.endAMEnable = true;
				}
			} else {
				this.endAMEnable = true;
			}
		},
		setBeginPM: function(){
			if (this.value.end !== null && this.value.end_term !== null){
				if ( this.value.begin === this.value.end && this.value.end_term == '0'){
					this.beginPMEnable = false;
				} else {
					this.beginPMEnable = true;
				}
			} else {
				this.beginPMEnable = true;
			}
		}
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		selectedClasses: function() {
			if(this.selected_class)
				return this.selected_class;
			else
				return this.value.classes;
		},
		form: function() {
			return {
				begin_date: this.value.begin,
				end_date: this.value.end,
			};
		},
		displayBegin: function(){
			if (!this.value.begin || !this.value.begin_term) return null;
			let term = '';
			if (!this.value.begin_term) return null;
			if (this.value.begin_term) {
				if (this.value.begin_term == ScheduleTick.TERM.AM) {
					term = TEXT_AM;
				} else {
					term = TEXT_PM;
				}
			}
			let ret = this.value.begin + term;
			return ret;
		},
		displayEnd: function(){
			if (!this.value.end || !this.value.end_term) return null;
			let term = '';
			if (this.value.end_term) {
				if (this.value.end_term == ScheduleTick.TERM.AM) {
					term = TEXT_AM;
				} else {
					term = TEXT_PM;
				}
			}
			return this.value.end + term;
		},
	},
	watch: {
		'value.begin_term': function (){
			if (this.value !== undefined && this.value !== null){
				this.setEndAM();
				this.setBeginPM();
			}
		},
		'value.end_term': function (){
			if (this.value !== undefined && this.value !== null){
				this.setEndAM();
				this.setBeginPM();
			}
		},
		'value.begin': function (){
			if (this.value !== undefined && this.value !== null){
				this.setEndAM();
				this.setBeginPM();
			}
		},
		'value.end': function (){
			if (this.value !== undefined && this.value !== null){
				this.setEndAM();
				this.setBeginPM();
			}
		},
	}
	
}
</script>
<style>
	.modal-window.member-filtering .row-group {
		min-height: 80px;
	}
	.modal-window.member-filtering .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.member-filtering .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.member-filtering .label_status {
		display: flex;
		justify-content: flex-start;
		font-size: 16px;
	}
	.modal-window.member-filtering .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.member-filtering .modal-header-member-filtering {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.member-filtering .btn-add-class {
		height: 24px;
		width: 24px;
		margin-top: 0px;
	}
	.btn-term-group {
		background-color: #ffffff !important;
		min-width: 290px !important;
	}
</style>
